module.exports = __webpack_public_path__ + "img/shareCode.fec2ce18.png";